import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.createStockSubLocationModal.title, 'Create stock Sub location'),
  location: () => __(translations.createStockSubLocationModal.location, 'Location'),
  name: () => __(translations.createStockSubLocationModal.name, 'Name'),
};
